export const isPlaceOccupied = (place, placesStock) => { var _a; return !((_a = placesStock[place.id]) !== null && _a !== void 0 ? _a : 1); };
//# sourceMappingURL=place.js.map